<nav class="flex w-full h-full items-center justify-around bg-pmdf-primary text-white/50 border-t border-white/10">
  <a routerLink="/dashboard"
     routerLinkActive="active-nav-item"
     class="flex-1 flex flex-col items-center justify-center gap-1 h-full active:scale-95 transition-transform">
    <mat-icon class="icon-lg">home</mat-icon>
    <span class="text-xs font-base tracking-tighter">Início</span>
  </a>

  <a routerLink="/perfil"
     routerLinkActive="active-nav-item"
     class="flex-1 flex flex-col items-center justify-center gap-1 h-full active:scale-95 transition-transform">
    <mat-icon class="icon-lg">person</mat-icon>
    <span class="text-xs font-base tracking-tighter">Perfil</span>
  </a>

  <a routerLink="/requerimentos"
     routerLinkActive="active-nav-item"
     class="flex-1 flex flex-col items-center justify-center gap-1 h-full active:scale-95 transition-transform">
    <mat-icon class="icon-lg">assignment</mat-icon>
    <span class="text-xs font-base tracking-tighter">Requerimento</span>
  </a>

  <a routerLink="/mensagens"
     routerLinkActive="active-nav-item"
     class="flex-1 flex flex-col items-center justify-center gap-1 h-full active:scale-95 transition-transform">
    <div class="relative -mb-2">
      <mat-icon class="icon-lg">mail</mat-icon>
      <span class="absolute -top-1.5 -right-1.5 w-2 h-2 bg-pmdf-warning rounded-full"></span>
    </div>
    <span class="text-xs font-base tracking-tighter">Mensagens</span>
  </a>

</nav>
